export default pantry => {
  const { streetAddress, city, county, state, zipCode } = pantry;
  const cityCounty = county ? `${city}, ${county}` : city;

  return `${streetAddress}, ${cityCounty}, ${state} ${zipCode}`.toUpperCase();
};
